export class OpenWithConfigurationForm {
    constructor () {
        this.enabledParameter = document.getElementById('enabledParameter');
        this.setupFileParameter();
        this.setupProjectParameter();
        this.openWithSettingsSaveButton = document.getElementById('openWithSettingsSaveButton');
        this.openWithSettingsCloseButton = document.getElementById('openWithSettingsCloseButton');
        this.openWithSettingsLink = document.getElementById('openWithSettingsLink');
        this.openWithSettingsLinkButton = document.getElementById('openWithSettingsLinkButton');
        this.openWithSettingsTryItButton = document.getElementById('openWithSettingsTryItButton');
        this.openWithSettingsModalAlertError = document.getElementById('openWithSettingsModalAlertError');
        this.openWithSettingsModaAlertSuccess = document.getElementById('openWithSettingsModaAlertSuccess');
        this.openInMatlabOnlineButton = document.getElementById('openInMatlabOnlineButton');
        this.openInMatlabOnlineButtonGroup = document.getElementById('openInMatlabOnlineButtonGroup');
        this.openWithShareLink = document.getElementById('openWithShareLink');
        this.openWithShareSection = document.getElementById('openWithShareSection');
        this.fileExchangeShareSection = document.getElementById('fileExchangeShareSection');

        // Initialize popover if needed
        this.popoverInstance = null;

        // Group elements that need to be disabled/enabled together
        this.formControls = [
            this.enabledParameter,
            this.fileParameter,
            this.projectParameter,
            this.openWithSettingsSaveButton,
            this.openWithSettingsCloseButton,
            this.openWithSettingsTryItButton,
            this.openWithSettingsLinkButton
        ].filter(Boolean); // Remove null/undefined elements
    }

    alertError () {
        if (this.openWithSettingsModalAlertError) {
            this.openWithSettingsModalAlertError.classList.remove('d-none');
        }
    }

    alertSuccess () {
        if (this.openWithSettingsModaAlertSuccess) {
            this.openWithSettingsModaAlertSuccess.classList.remove('d-none');
        }
    }

    configurationWasUpdated (configuration, newConfiguration) {
        const enabledChanged = configuration.enabled !== newConfiguration.enabled;
        const fileChanged = configuration.file !== newConfiguration.file;
        const projectChanged = configuration.project !== newConfiguration.project;
        return enabledChanged || fileChanged || projectChanged;
    }

    // Helper method to safely set attribute on elements
    setAttributeOnElements (elements, attribute, value) {
        elements.forEach(element => {
            if (element) {
                if (value === null) {
                    element.removeAttribute(attribute);
                } else {
                    element.setAttribute(attribute, value);
                }
            }
        });
    }

    disable () {
        this.setAttributeOnElements(this.formControls, 'disabled', true);
    }

    enable () {
        this.setAttributeOnElements(this.formControls, 'disabled', null);
    }

    getConfiguration () {
        return {
            enabled: this.enabledParameter.dataset.savedValue === 'true',
            file: this.fileParameter.dataset.savedValue,
            project: this.projectParameter.dataset.savedValue
        };
    }

    getNewConfiguration () {
        return {
            enabled: this.enabledParameter.checked,
            file: this.fileParameter.value,
            project: this.projectParameter.value
        };
    }

    hideAlerts () {
        if (this.openWithSettingsModalAlertError) {
            this.openWithSettingsModalAlertError.classList.add('d-none');
        }
        if (this.openWithSettingsModaAlertSuccess) {
            this.openWithSettingsModaAlertSuccess.classList.add('d-none');
        }
    }

    hideFeedback () {
        if (this.fileParameterGroup) {
            this.fileParameterGroup.classList.remove('has-feedback', 'has-success', 'has-warning');
        }
        if (this.fileParameterGroupErrorMessage) {
            this.fileParameterGroupErrorMessage.classList.add('d-none');
        }
        if (this.projectParameterGroup) {
            this.projectParameterGroup.classList.remove('has-feedback', 'has-success', 'has-warning');
        }
        if (this.projectParameterGroupErrorMessage) {
            this.projectParameterGroupErrorMessage.classList.add('d-none');
        }
    }

    reset () {
        this.resetAlertsAndFeedback();
        const configuration = this.getConfiguration();
        const link = this.openWithSettingsLink.dataset.savedValue;
        this.setFormValues(configuration, link);
    }

    resetAlertsAndFeedback () {
        this.hideAlerts();
        this.hideFeedback();
    }

    async save () {
        if (!this.openWithSettingsSaveButton) {
            console.warn('OpenWithConfigurationForm: Save button not found');
            return;
        }

        this.resetAlertsAndFeedback();
        const configuration = this.getConfiguration();
        const newConfiguration = this.getNewConfiguration();

        if (this.configurationWasUpdated(configuration, newConfiguration)) {
            this.disable();
            this.showSavingText();
            await this.sendRequest(newConfiguration);
            this.showSaveText();
            this.enable();
        } else {
            this.alertSuccess();
            setTimeout(() => this.hideAlerts(), 2000);
        }
    }

    async sendRequest (newConfiguration) {
        const versionUUID = this.openWithSettingsSaveButton.dataset.versionUuid;
        const url = window.location.origin + `/matlabcentral/fileexchange/open_with_configurations/${versionUUID}`;
        const configurationData = new FormData();
        configurationData.append('configuration', JSON.stringify(newConfiguration));
        const csrfToken = document.querySelector('meta[name=csrf-token]');

        const request = {
            body: configurationData,
            headers: {
                'X-CSRF-Token': csrfToken ? csrfToken.getAttribute('content') : ''
            },
            method: 'POST',
            mode: 'same-origin'
        };

        try {
            const response = await fetch(url, request);
            const body = await response.json();
            this.update(body);
            this.alertSuccess();
            setTimeout(() => this.hideAlerts(), 5000);
        } catch {
            this.alertError();
        }
    }

    setFormValues (configuration, link) {
        if (this.enabledParameter) {
            this.enabledParameter.checked = configuration.enabled;
            this.enabledParameter.dataset.savedValue = configuration.enabled;
        }
        this.updateValueAndDatasetForElement(this.fileParameter, configuration.file);
        this.updateValueAndDatasetForElement(this.projectParameter, configuration.project);
        this.updateValueAndDatasetForElement(this.openWithSettingsLink, link);
        if (this.openWithSettingsTryItButton) {
            this.openWithSettingsTryItButton.href = link;
        }
    }

    setupFileParameter () {
        this.fileParameterGroup = document.getElementById('fileParameterGroup');
        this.fileParameterGroupErrorMessage = document.getElementById('fileParameterGroupErrorMessage');
        this.fileParameter = document.getElementById('fileParameter');
    }

    setupProjectParameter () {
        this.projectParameterGroup = document.getElementById('projectParameterGroup');
        this.projectParameterGroupErrorMessage = document.getElementById('projectParameterGroupErrorMessage');
        this.projectParameter = document.getElementById('projectParameter');
    }

    showFileWarning () {
        if (this.fileParameterGroup) {
            this.fileParameterGroup.classList.add('has-feedback', 'has-warning');
        }
        if (this.fileParameterGroupErrorMessage) {
            this.fileParameterGroupErrorMessage.classList.remove('d-none');
        }
    }

    showFileSuccess () {
        if (this.fileParameterGroup) {
            this.fileParameterGroup.classList.add('has-feedback', 'has-success');
        }
        if (this.fileParameterGroupErrorMessage) {
            this.fileParameterGroupErrorMessage.classList.add('d-none');
        }
    }

    showProjectWarning () {
        if (this.projectParameterGroup) {
            this.projectParameterGroup.classList.add('has-feedback', 'has-warning');
        }
        if (this.projectParameterGroupErrorMessage) {
            this.projectParameterGroupErrorMessage.classList.remove('d-none');
        }
    }

    showProjectSuccess () {
        if (this.projectParameterGroup) {
            this.projectParameterGroup.classList.add('has-feedback', 'has-success');
        }
        if (this.projectParameterGroupErrorMessage) {
            this.projectParameterGroupErrorMessage.classList.add('d-none');
        }
    }

    showSaveText () {
        if (this.openWithSettingsSaveButton) {
            this.openWithSettingsSaveButton.innerText = this.openWithSettingsSaveButton.dataset.saveText;
        }
    }

    showSavingText () {
        if (this.openWithSettingsSaveButton) {
            this.openWithSettingsSaveButton.innerText = this.openWithSettingsSaveButton.dataset.savingText;
        }
    }

    update ({ configuration, link }) {
        this.setFormValues(configuration, link);
        if (configuration.enabled) {
            if (this.openInMatlabOnlineButton) {
                // Enable the button
                this.openInMatlabOnlineButton.classList.remove('disabled');
                this.openInMatlabOnlineButton.setAttribute('href', link);
                this.openInMatlabOnlineButton.setAttribute('target', '_blank');
                this.openInMatlabOnlineButton.removeAttribute('aria-disabled');
                this.openInMatlabOnlineButton.removeAttribute('tabindex');
            }
            if (this.openWithShareLink) {
                this.openWithShareLink.value = link;
            }
            if (this.openWithShareSection) {
                this.openWithShareSection.classList.remove('d-none');
            }
            if (this.fileExchangeShareSection) {
                const div = this.fileExchangeShareSection.getElementsByTagName('div')[0];
                if (div) div.classList.add('add_margin_20');
            }
            if (configuration.file || configuration.project) {
                this.disablePopover();
            } else {
                if (this.openInMatlabOnlineButtonGroup) {
                    this.updatePopover(
                        this.openInMatlabOnlineButtonGroup,
                        this.openInMatlabOnlineButtonGroup.dataset.bsContentEnabled
                    );
                }
            }
        } else {
            if (this.openInMatlabOnlineButton) {
                // Disable the button
                this.openInMatlabOnlineButton.classList.add('disabled');
                this.openInMatlabOnlineButton.removeAttribute('href');
                this.openInMatlabOnlineButton.removeAttribute('target');
                this.openInMatlabOnlineButton.setAttribute('aria-disabled', 'true');
                this.openInMatlabOnlineButton.setAttribute('tabindex', '-1');
            }
            if (this.openInMatlabOnlineButtonGroup) {
                this.updatePopover(
                    this.openInMatlabOnlineButtonGroup,
                    this.openInMatlabOnlineButtonGroup.dataset.bsContentDisabled
                );
            }
            if (this.openWithShareSection) {
                this.openWithShareSection.classList.add('d-none');
            }
            if (this.fileExchangeShareSection) {
                const div = this.fileExchangeShareSection.getElementsByTagName('div')[0];
                if (div) div.classList.remove('add_margin_20');
            }
        }
    }

    updatePopover (element, content) {
        if (!element) return;

        this.enablePopover();
        if (element.dataset.bsTrigger == 'manual') {
            this.destroyPopover(element);

            element.dataset.bsContent = content;
            element.dataset.bsTrigger = 'hover';

            this.createPopover(element, {
                html: true,
                trigger: 'hover'
            });
        } else {
            element.dataset.bsContent = content;
            if (this.popoverInstance) {
                this.popoverInstance._config.content = content;
            }
        }
    }

    createPopover (element, options) {
        if (typeof bootstrap !== 'undefined' && bootstrap.Popover) {
            this.popoverInstance = new bootstrap.Popover(element, options);
        }
    }

    destroyPopover (element) {
        if (this.popoverInstance) {
            this.popoverInstance.dispose();
            this.popoverInstance = null;
        }
    }

    enablePopover () {
        if (this.popoverInstance) {
            this.popoverInstance.enable();
        } else if (this.openInMatlabOnlineButtonGroup) {
            this.createPopover(this.openInMatlabOnlineButtonGroup, {
                html: true,
                trigger: 'hover'
            });
        }
    }

    disablePopover () {
        if (this.popoverInstance) {
            this.popoverInstance.disable();
        }
    }

    updateValueAndDatasetForElement (element, value) {
        if (element) {
            element.value = value;
            element.dataset.savedValue = value;
        }
    }

    validateAndUpdateLink () {
        if (!this.fileParameter) return;

        const configuration = this.getNewConfiguration();
        const versionFiles = JSON.parse(this.fileParameter.dataset.versionFileList || '[]');
        const versionProjects = JSON.parse(this.fileParameter.dataset.versionProjectList || '[]');
        const openWithLink = new URL(this.openWithSettingsLink.value);

        openWithLink.searchParams.delete('file');
        openWithLink.searchParams.delete('project');

        let newLink = openWithLink.origin + openWithLink.pathname + openWithLink.search;

        if (configuration.file) {
            if (versionFiles.includes(configuration.file)) {
                this.showFileSuccess();
            } else {
                this.showFileWarning();
            }
            newLink += `&file=${configuration.file}`;
        }

        if (configuration.project) {
            if (versionProjects.includes(configuration.project)) {
                this.showProjectSuccess();
            } else {
                this.showProjectWarning();
            }
            newLink += `&project=${configuration.project}`;
        }

        if (this.openWithSettingsLink) {
            this.openWithSettingsLink.value = newLink;
        }
        if (this.openWithSettingsTryItButton) {
            this.openWithSettingsTryItButton.href = newLink;
        }
    }
}
